/**
 * @generated SignedSource<<9491589b2c5a96091f816aa51c01046c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GorgiasCard_brand$data = {
  readonly appConfig: {
    readonly buildNavigation: {
      readonly id: string;
      readonly isGorgiasEnabled: boolean;
    };
    readonly id: string;
  };
  readonly gorgiasId: string | null;
  readonly " $fragmentType": "GorgiasCard_brand";
};
export type GorgiasCard_brand$key = {
  readonly " $data"?: GorgiasCard_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"GorgiasCard_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GorgiasCard_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "BrandAppConfigBuildNavigationType",
          "kind": "LinkedField",
          "name": "buildNavigation",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isGorgiasEnabled",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gorgiasId",
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "9b7537d2e0c3703b94bdfe7f17b56d14";

export default node;
